import {
    mapState,
    mapActions,
    // mapGetters
} from 'vuex'
import viewName from '../constant.js'
import Swiper from '@/components/swiper/swiper.tpl.vue'
import StoreCard from '@/components/storeCard/storeCard.tpl.vue'
import pageNotFound from '../pageNotFound/index.vue'
import Sku from '@/components/sku/sku.tpl.vue'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import Seckill from '@/components/seckillCard/seckillCard.vue'
import SwiperBox from './components/swiper'
import DeliveryGoodsBox from './components/deliveryGoodsBox'
import SelectedSkuBox from './components/selectedSkuBox'
import GuideBox from './components/guideBox'
import TabsBox from './components/tabsBox'
import GuideFloating from '@/components/guideFloating/guideFloating'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import onlineCustomerDialog from '@/components/onlineCustomerDialog/onlineCustomerDialog.vue'
// import { getLoginInfo } from '@/utils/loginInfo'

import {
    getDistributionDetail,
    getDistributionDetailSpecList
} from '@/models/distributionDetail'
import {
    setLocalConfig
} from '@/utils/session'
import {
    wxShare,
    // wxSharebyData,
    // wxConfig
} from '@/utils/wxsdk'
import {
    postBindDistributorCode
} from '@/models/confirmOrder'
import { Cell } from 'vant'

export default {
    inject: ['showLoading', 'hideLoading', 'queryKey'],
    name: viewName.goodsDetail,
    components: {
        Swiper,
        StoreCard,
        Sku,
        pageNotFound,
        QualityImg,
        Seckill,
        SwiperBox,
        DeliveryGoodsBox,
        SelectedSkuBox,
        GuideBox,
        TabsBox,
        Cell,
        GuideFloating,
        appGuideDialog,
        'online-Dialog': onlineCustomerDialog
    },
    data () {
        return {
            hasStore: false,
            position: {
                longitude: '',
                latitude: ''
            },
            endStatus: 1, // 1: 默认状态 2: 倒计时为0秒 3: 活动已经结束
            seckillTime: '10',
            current_selectedSkuComb: '',
            curWay: 'store', // 默认的提货方式
            initSku: {}, // 初始化sku值
            skus: {}, // 规格参数
            // tab选择
            tabActive: 0,
            // 选中的规格数据，与数量
            selectedSku: {
                num: 1
            },
            // 标签列表 is_proprietary( 0/1, //  1是自营 0是代理) 自营不显示：邮寄到家，显示到店提货
            tags: [{
                name: '邮寄到家',
                show: false
            },
            {
                name: '厂商直接发货',
                show: false
            },
            {
                name: '到店提取现货',
                show: false
            },
            {
                name: '免费安装',
                show: false
            }
            ],
            detailParams: {},
            // 详情页数据
            detail: null,
            isShowPageNot: false,
            sstore_id: '', // 门店id
            isSellOut: true, // 是否已售罄
            /* 浮动按钮 */
            floatBtn:[
                {
                    key: 'sstores_in',
                    top: '70',
                    right: '10px'
                }
            ],
            jumpType: 'home' // 跳转小程序路径
        }
    },
    watch: {
        detail (val) {
            let tags = this.tags
            // 邮寄到家-支持邮寄的活动分销商品
            tags[0].show = val.delivery_goods.express_status === 1
            // 厂商直接发货-代理商品
            tags[1].show = val.goods.is_proprietary === 0
            // 到店提取现货
            tags[2].show = val.goods.is_proprietary === 1
            // 免费安装 选择门店后，若门店勾选“已包含”安装费，则显示，否则隐藏。点击        弹出窗口，见右图
            tags[3].show = val.delivery_goods.free_install === 1
            this.tags = tags
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin
        }),
        // ...mapGetters([
        //     'wxUserInfo'
        // ]),
        isMoreThan () {
            return !this.detailParams.sstore_id
        }
    },
    async created () {
        /** 页面入参说明
         * spu_id: 商品id
         * sstore_id: 门店id
         * spec_id: b2b_规格id
         * spu_id=10668&sstore_id=1382&spec_id=7454
         */

        // 调取，用于通过code获取用户信息并且保存到本地并且进行绑定手机号码的逻辑
        // await this.getWxUserInfo(this.$route.query.code || '')
        // const pathData = this.$route.path
        // let routequery = this.$route.query
        // routequery['code'] && delete routequery['code'] && this.$router.replace(`${pathData}?${toQueryObject(routequery)}`)

        /*
         * 绑定分销关系
         * @params { distribution_store_type } 1: 门店多店 2: 门店单店
         * @params { distribution_user_type } 1:平台分销员, 2:门店分销员 3:平台&门店分销员
         */
        // const { distribution_code, distribution_store_type, sstore_id } = this.detailParams
        // const userInfo = getLoginInfo()
        // if (userInfo && userInfo.token) {
        //     /* 1:平台分销员 3:平台&门店分销员 进来就绑定关系 */
        //     if (userInfo.distribution_user_type === 1 || userInfo.distribution_user_type === 3) {
        //         this.postBindDistributionCode(distribution_code)
        //     }
        //     /* 判断是否门店多店来源 并且选择了门店 */
        //     if (Number(distribution_store_type) === 1 && !!sstore_id) {
        //         this.postBindDistributionCode(distribution_code, sstore_id)
        //     }
        //     /* 门店主页-分销商品详情 (门店单店) H5 */
        //     if ((userInfo.distribution_user_type === 2 || userInfo.distribution_user_type === 3) && !!sstore_id) {
        //         this.postBindDistributionCode(distribution_code, sstore_id)
        //     }
        // }
    },
    async mounted () {
        /* 定义页面必传的参数，遍历参数，保存详情路径到本地存储，GOODSDETAIL */
        setLocalConfig('GOODSDETAIL', this.$route.fullPath)
        this.detailParams = this.$route.query
        this.queryKey(this.detailParams, ['spu_id',  'spec_id']).then(_ => {
            this.render({ ...this.detailParams })
            // if (!this.detailParams.sstore_id) {
            this.getMyLocation()
            // }
        })

        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
    },
    async activated () {
        if (this.current_selectedSkuComb) {
            let {
                store,
                // goods
            } = this.detail
            let selectedSkuComb = this.current_selectedSkuComb
            // this.apiDetail({
            //     sstore_id: store.sstore_id,
            //     spu_id: selectedSkuComb.spu_id | goods.spu_id,
            //     goods_id: selectedSkuComb.goods_id || goods.goods_id,
            //     goods_type: selectedSkuComb.goods_type || goods.goods_type
            // })
            this.render({
                spu_id: selectedSkuComb.spu_id,
                sstore_id: store.sstore_id,
                spec_id: selectedSkuComb.spec_id
            })
        }
    },
    methods: {
        ...mapActions(['setAppClass', 'getWxUserInfo', 'verifyUserInfo', 'getLocation']),
        // 微信分享
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    ...detail
                })
            }
        },
        getMyLocation () {
            const options = { timeout: 3000 }
            this.getLocation(options).then(this.showPosition).catch(this.showErr)
        },
        /* 获取位置信息成功 */
        showPosition ({lng, lat}) {
            this.position.longitude = lng
            this.position.latitude = lat
            // this.longitude = 113.326233
            // this.latitude = 23.197102
            this.hideLoading()
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            // 定位同和地铁站
            // this.position.longitude = lng
            // this.position.latitude = lat
            this.hideLoading()
        },
        async render (params) {
            return new Promise(async (resolve, reject) => {
                const {distribution_code, distribution_store_type} = this.$route.query
                let response = await this.apiDetail({
                    spu_id: params.spu_id,
                    sstore_id: params.sstore_id,
                    b2b_spec_id: params.spec_id,
                    distribution_store_type: distribution_store_type,
                    distribution_code: distribution_code
                })
                // 商品下架跳转逻辑
                if (response.errcode === 6003) {
                    this.$dialog
                        .alert({
                            message: '该商品已下架'
                        }).then(() => {
                            this.$router.go(-1)
                        })
                } else if (response.errcode === 9001) {
                    this.alertError('推广商品已失效，无法购买')
                } else if (response.errcode === 9002) {
                    this.alertError('暂无门店销售此商品')
                } else if (response.errcode === 9003) {
                    this.alertError('很抱歉，您访问的页面失效了')
                } else {
                    if (response.goods) {
                        this.detail = response
                        this.hasStore = !(this.detail.store instanceof Array)
                        this.apiGoodsSpecList(response)
                        resolve(response)
                    }
                }
            })
        },
        alertError (message) {
            this.$dialog
                .alert({
                    confirmButtonText: '我知道了',
                    message
                }).then(() => {
                    this.$refs.appGuideDialog.open()
                })
        },
        // 去到分销门店列表
        toStoreList (
            action = 'select',
            params = {
                sstore_id: this.detailParams.sstore_id || '',
                spec_id:  this.detailParams.spec_id,
                spu_id:  this.detailParams.spu_id,
                longitude:  this.position.longitude,
                latitude:  this.position.latitude,
                distribution_code: this.detailParams.distribution_code || '',
                distribution_store_type: this.detailParams.distribution_store_type || ''
            }) {
            /* 如果是门店单店 不可点击 */
            if (Number(this.detailParams.distribution_store_type) !== 2) {
                this.verifyUserInfo({
                    type: 'back'
                }).then(_ => {
                    this.$router.push({
                        name: 'distributionStoreList',
                        query: Object.assign({
                            action,
                        }, params)
                    })
                })
            }
        },
        // 打开规格
        open () {
            const { all_goods_by_stock,  all_goods_by_sstore } = this.detail.goods
            if (Number(all_goods_by_stock) > 0 || Number(all_goods_by_sstore) > 0) {
                this.$refs.sku.open()
            }
        },
        // 关闭规格
        close () {
            this.$refs.sku.close()
        },
        // 请求详情页
        apiDetail (params, type) {
            this.showLoading()
            return new Promise(async (resolve, reject) => {
                // 后端需要通过这个参数区分是不是通过分享链接进来的
                this.detailParams.share_sstore_id && Object.assign(params, {share_sstore_id: this.detailParams.share_sstore_id})
                getDistributionDetail(params).then((response) => {
                    // if (type !== 'buyNow') {
                    this.$emit('setHeader', {
                        title: response.goods.goods_name,
                        showHeader: true,
                        showLeft: true
                    })

                    let shareData = {
                        title: response.share.title, // 分享标题
                        desc: response.share.desc, // 分享描述
                        imgUrl: response.share.imgUrl
                    }
                    this.configWxShare(shareData)
                    this.hideLoading()
                    resolve(response)
                }).catch(res => {
                    resolve(res)
                    this.hideLoading()
                })
            })
        },
        // 请求sku规格
        async apiGoodsSpecList (response) {
            let {
                goods,
                // store
            } = response
            let skus = await getDistributionDetailSpecList({
                distribution_store_type: this.detailParams.distribution_store_type,
                b2b_spec_id: this.detailParams.spec_id,
                // goods_type: this.detailParams.goods_type, // 商品类型（proprietary:自营，agent：代理）
                // goods_id: this.detailParams.goods_id, // 商品规格id
                spu_id: this.detailParams.spu_id, // 商品id
                sstore_id: this.detailParams.sstore_id || '' // 门店id
            })
            // 初始化sku值用于传入sku组件rr
            this.skus = {
                ...skus
            }

            let img_url = goods.goods_imgs_url[0]

            // 如果是视频就走第二个
            if (img_url.indexOf('mp4') > -1) {
                img_url = goods.goods_imgs_url[1]
            }

            this.initSku = {
                discount: goods.goods_price || 0, // 支付价格
                id: goods.goods_id, // id
                img_url, // 图片
                price: goods.goods_original_price, // 原价
                s1: goods.goods_spec[0], // 默认规格
                s2: goods.goods_spec[1], // 默认规格2
                sku_name: goods.goods_name, // 规格名称
                spu_id: goods.spu_id, // 商品id
                stock_num: goods.goods_stock // 库存
            }
        },
        // 确认
        confirm (e) {
            if (this.skus.sku.none_sku === 1) {
                let {
                    selectedSkuComb
                } = e
                let {
                    goods_id,
                    spu_id,
                } = this.detail.goods
                let {
                    sstore_id
                } = this.detail.store
                if (Number(selectedSkuComb.id) !== Number(goods_id)) {
                    this.detailParams.spec_id = selectedSkuComb.spec_id
                    this.render({
                        spu_id: spu_id,
                        sstore_id: sstore_id,
                        spec_id: selectedSkuComb.spec_id,
                    })
                }
                this.close()
            } else {
                this.close()
            }
        },
        postBindDistributionCode (code, store_id) {
            if (code) {
                postBindDistributorCode({
                    distribution_code: code || '',
                    store_id: store_id || ''
                })
            }
        },
        // 立即购买
        buyNowToOrder (e) {
            let {
                selectedNum,
                selectedSkuComb,
            } = e
            const { spec_id = this.$route.query.spec_id, spu_id = this.$route.query.spu_id } = selectedSkuComb
            this.verifyUserInfo({
                type: 'back'
            }).then(_ => {
                if (selectedSkuComb) {
                    // 判断是否有商品数量
                    if (this.detailParams.sstore_id) {
                    // 保存数据
                        this.setGoodsDetaStorage(selectedNum, selectedSkuComb)
                        this.$router.push({
                            name: 'confirmOrder',
                            query: {
                                distribution_code: this.$route.query.distribution_code
                            }
                        })
                        if (this.skus.sku.none_sku === 1) {
                            this.current_selectedSkuComb = selectedSkuComb
                        }
                    } else {
                        this.toStoreList('buy', {
                            sstore_id: this.detailParams.sstore_id || '',
                            spec_id: spec_id,
                            spu_id: spu_id,
                            longitude:  this.position.longitude,
                            latitude:  this.position.latitude,
                            distribution_code: this.$route.query.distribution_code || '',
                            distribution_store_type: this.detailParams.distribution_store_type || ''
                        })
                        this.setGoodsDetaStorage(selectedNum, selectedSkuComb)
                    }
                }
                // this.confirm(e)
            })
        },
        // 设置存放订单数据
        setGoodsDetaStorage (selectedNum, selectedSkuComb) {
            // const { curWay } = this
            const {
                goods
            } = this.detail
            setLocalConfig('CONFIRM_ORDER', {
                // expressStatus: delivery_goods.express_status === 1,
                // curWay, // 默认的提货方式
                sstore_id: this.detailParams.sstore_id, // 门店id
                goods: [{
                    goods_id: selectedSkuComb.id || goods.goods_id,
                    goods_type: selectedSkuComb.goods_type || goods.goods_type,
                    quantity: selectedNum
                }]
            })
        },
        // 展示免费安装提示信息
        showOperateTips () {
            this.$dialog.alert({
                message: '仅包含按正规操作流程安装本商品时的安装服务费用'
            })
        }
    },
    destroyed () {
        this.hideLoading()
    },
    beforeRouteLeave (to, from, next) {
        // 设置下一个路由的meta
        // 如果页面是specialActivity或者marketingDetail是不关闭缓存
        if (to.name !== 'specialActivity' || to.name !== 'marketingDetail') {
            to.meta.keepAlive = false
        } else {
            // to.meta.keepAlive =
        }
        next()
    },
}
